import React from 'react';
import _ from 'lodash';

// mui
import { Grid, Box, Typography, Switch } from '@mui/material';
import { makeStyles } from '@mui/styles';

// components
import { PolicyEndorseCompare } from './PolicyEndorseCompare';
import {
  getCoverageFormat,
  getCoverageFormatV6,
  isBoostV6,
  getKeysForUpdatedCoverages,
  getDiffCoveragesSummary,
} from '../endorsement.utils';

export const CoveragesSummary = ({
  previous = {},
  current = {},
  existingKeys = [],
  boostRaterVersion = undefined,
}) => {
  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);
  const formatFn = isBoostV6(boostRaterVersion)
    ? getCoverageFormatV6
    : getCoverageFormat;
  const formattedCoverages = formatFn(previous);
  const formattedEndorsements = formatFn(current);

  const consolidatedKeys = _.isEmpty(existingKeys)
    ? getKeysForUpdatedCoverages(formattedCoverages, formattedEndorsements)
    : existingKeys;

  let coverages = previous;
  let endorsements = current;

  if (checked) {
    coverages = formattedCoverages;
    endorsements = formattedEndorsements;
  }

  if (!checked) {
    coverages = getDiffCoveragesSummary(consolidatedKeys, formattedCoverages);
    endorsements = getDiffCoveragesSummary(
      consolidatedKeys,
      formattedEndorsements
    );
  }

  const handleSwitch = (event: any) => {
    setChecked(event.target.checked);
  };

  if (_.isEmpty(consolidatedKeys)) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Box className={classes.subHeader}>
        <Grid container>
          <Grid item md={6}>
            <Typography className={classes.subHeaderTitle}>
              Coverage/Limits
            </Typography>
          </Grid>

          <Grid item md={6}>
            <Switch name="showAll" checked={checked} onChange={handleSwitch} />
            <span className={classes.switch}>Show All</span>
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.container}>
        <PolicyEndorseCompare
          coverages={coverages}
          endorsement={endorsements}
          diffs={consolidatedKeys}
        />
      </Box>
    </Grid>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  subHeader: {
    display: 'flex',
    padding: '0.5em 2em',
    backgroundColor: palette.background.customTable,
    borderRadius: 5,
    lineHeight: 1.4,
    marginBottom: '1.66rem',
  },
  subHeaderTitle: {
    color: palette.primary.contrastText,
    fontSize: config.textSizes.paragon,
    fontWeight: 'normal',
    lineHeight: 1.4,
  },
  container: {
    margin: '0 2rem 1.66em',
    padding: '0.5rem 0',
    border: `1px solid ${config.colors.paleGrey1}`,
  },
  switch: {
    color: config.colors.cowbellBlue,
    fontSize: config.textSizes.primer,
    fontWeight: config.weights.bold,
    lineHeight: 0.75,
  },
}));
